import { useCopyPasteHandlers } from './useCopyPasteHandlers';
import { useKeyboardKeyEvent } from 'flow/editor/hooks/useKeyboardKeyEvent';
import { isTargetInputElement } from './helpers';
import { copyShortcut, pasteShortcut } from 'flow/editor/hooks/useKeyboardKeyEvent/constants';

type SnippetCopyPasteProps = {
  isCanvasFocused: boolean;
};

export default function SnippetCopyPaste({ isCanvasFocused }: SnippetCopyPasteProps) {
  const { handleCopy, handlePaste } = useCopyPasteHandlers();

  useKeyboardKeyEvent({
    enabled: isCanvasFocused,
    shortcut: copyShortcut,
    callback: event => {
      if (!isTargetInputElement(event)) {
        handleCopy();
      }
    },
  });

  useKeyboardKeyEvent({
    enabled: isCanvasFocused,
    shortcut: pasteShortcut,
    callback: event => {
      if (!isTargetInputElement(event)) {
        handlePaste();
      }
    },
  });

  return null;
}

